import { useRuntimeConfig } from '#imports';

export default class PreviewHelper {
  private static readonly CLIENT_ID_STORAGE_KEY = 'previewClientId';
  private static readonly URL_STORAGE_KEY = 'previewUrl';
  private static readonly DEFAULT_URL = 'https://example.com';

  public static buildRedirectUrl(url: string, clientId: string): string {
    return `${url}?dataLayerPreview=1&clientId=${clientId}`;
  }

  public static getClientId(): string {
    return this.getStorageValue(this.CLIENT_ID_STORAGE_KEY) || useRuntimeConfig().public.previewClientId;
  }

  public static getUrl(): string {
    return this.getStorageValue(this.URL_STORAGE_KEY) || this.DEFAULT_URL;
  }

  public static setClientId(clientId: string) {
    localStorage.setItem(this.CLIENT_ID_STORAGE_KEY, clientId);
  }

  public static setUrl(url: string) {
    localStorage.setItem(this.URL_STORAGE_KEY, url);
  }

  private static getStorageValue(key: string): string {
    return localStorage.getItem(key) ?? '';
  }
}
